// extracted by mini-css-extract-plugin
export var wordContainer = "_qr-0";